const dataTeam = [
  {
    id: '1',
    imgUrl: require('../../images/team/Oleksandr_Pidvysotskyi.jpg'),
    name: 'Oleksandr Pidvysotskyi',
    role: 'Team Lead - Backend',
    linkGit: 'https://github.com/Pidvysotskyi',
    linkedin: 'https://www.linkedin.com/in/pidvysotskyioleksandr/',
  },
  {
    id: '2',
    imgUrl: require('../../images/team/5_Veronika_Savluk.jpeg'),
    name: 'Veronika Savluk',
    role: 'Team Lead - Frontend',
    linkGit: 'https://github.com/VeronikaSavluk',
    linkedin: 'https://www.linkedin.com/in/veronikasavluk',
  },
  {
    id: '3',
    imgUrl: require('../../images/team/Bogdan_Karpenko.jpg'),
    name: 'Bogdan Karpenko',
    role: 'Team Lead - QA',
    linkGit: 'https://github.com',
    linkedin: 'https://www.linkedin.com/in/богдан-карпенко-814008259/',
  },
  {
    id: '4',
    imgUrl: require('../../images/team/4_Nataliia_Pogreniak.jpg'),
    name: 'Nataliia Pogrebniak',
    role: 'Scrum master',
    linkGit: 'https://github.com/PNataliya',
    linkedin: 'https://www.linkedin.com/in/nataliya-pogrebnyak-fullstack/',
  },
  {
    id: '5',
    imgUrl: require('../../images/team/7_Nikita_Rohovoi.jpeg'),
    name: 'Nikita Rohovoi',
    role: 'Frontend developer',
    linkGit: 'https://github.com/NRohovoi',
    linkedin: 'https://www.linkedin.com/in/nikita-rohovoi-6a4aa9241',
  },
  {
    id: '6',
    imgUrl: require('../../images/team/Victoria_Myzyniuk.jpg'),
    name: 'Victoria Myzyniuk',
    role: 'Frontend developer',
    linkGit: 'https://github.com/VictoriaMyzyniuk',
    linkedin: 'https://www.linkedin.com/in/victoria-myzyniuk-491037217/',
  },
  {
    id: '7',
    imgUrl: require('../../images/team/9_Stas_Korobchenko.jpeg'),
    name: 'Stanislav Korobchenko',
    role: 'Frontend developer',
    linkGit: 'https://github.com/Stasxxx',
    linkedin: 'https://www.linkedin.com/in/stanislav-korobchenko-b090b9126',
  },
  {
    id: '8',
    imgUrl: require('../../images/team/Andrii_Pidlubnyi.jpg'),
    name: 'Andrii Pidlubnyi',
    role: 'Frontend developer',
    linkGit: 'https://github.com/Apodlubny',
    linkedin: 'https://www.linkedin.com/in/andriipidlubnyi/',
  },
  {
    id: '13',
    imgUrl: require('../../images/team/Andrii_Kapustnikov.jpg'),
    name: 'Andrii Kapustnikov',
    role: 'Frontend developer',
    linkGit: 'https://github.com/AndreyKapus',
    linkedin: 'https://www.linkedin.com/in/andrii-kapustnikov-473925254/',
  },
  {
    id: '9',
    imgUrl: require('../../images/team/11_Viktor_Hrimli.jpg'),
    name: 'Viktor Hrimli',
    role: 'Full Stack developer',
    linkGit: 'https://github.com/ViktorHrimli',
    linkedin: 'https://www.linkedin.com/in/viktorhrimli/',
  },
  {
    id: '11',
    imgUrl: require('../../images/team/Artem_Raskhodchikov.jpg'),
    name: 'Artem Raskhodchikov',
    role: 'Backend developer',
    linkGit: 'https://github.com/raskhodchikoff',
    linkedin: 'https://www.linkedin.com/in/raskhodchikoff/',
  },
  {
    id: '10',
    imgUrl: require('../../images/team/Bohdan_Kovalov.jpg'),
    name: 'Bohdan Kovalov',
    role: 'QA engineer',
    linkGit: 'https://github.com',
    linkedin: 'https://www.linkedin.com/in/bohdankovalov',
  },

  {
    id: '12',
    imgUrl: require('../../images/team/Kirill_Zerkal.jpg'),
    name: 'Kirill Zerkal',
    role: 'QA engineer',
    linkGit: 'https://github.com',
    linkedin: 'https://www.linkedin.com/in/kirill-zerkal/',
  },

  {
    id: '14',
    imgUrl: require('../../images/team/Artur_Kovalov.jpg'),
    name: 'Artur Kovalov',
    role: 'QA engineer',
    linkGit: 'https://github.com',
    linkedin: 'https://www.linkedin.com/in/artur-kovalov-0457b5227/',
  },
  {
    id: '15',
    imgUrl: require('../../images/team/plug.png'),
    name: 'Olena Halan',
    role: 'QA engineer',
    linkGit: 'https://github.com',
    linkedin: 'https://www.linkedin.com/',
  },
];

export default dataTeam;
